"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var breadcrumbs_1 = require("../../ProductsApp/ducks/breadcrumbs");
var BreadcrumbsContainer_1 = __importDefault(require("../../ProductsApp/components/BreadcrumbsContainer"));
var styled_components_1 = __importDefault(require("styled-components"));
var AboutCompany_1 = __importDefault(require("./AboutCompany"));
var Menu_1 = __importDefault(require("../../ProductsApp/components/Menu"));
var ProductContainer_1 = __importDefault(require("./ProductContainer"));
var Instruction_1 = __importDefault(require("./Instruction"));
var Reviews_1 = __importDefault(require("./Reviews"));
var PopularProducts_1 = __importDefault(require("./PopularProducts"));
var OtherProducts_1 = __importDefault(require("./OtherProducts"));
var WhyUs_1 = __importDefault(require("./WhyUs"));
var Trusted_1 = __importDefault(require("../../service-landings/common/Trusted"));
var CTAForm_1 = __importDefault(require("../../common/CTAForm"));
var authenticity_token_1 = require("../../ProductsApp/ducks/authenticity-token");
var site_key_1 = require("../ducks/site-key");
var CustomStoreInfo_1 = __importDefault(require("./CustomStoreInfo"));
var PrintInfo_1 = __importDefault(require("./PrintInfo"));
var selectors_1 = require("../../common/selectors");
var content_1 = require("../../ProductsApp/ducks/content");
var Root = function () {
    var breadcrumbs = (0, react_redux_1.useSelector)(breadcrumbs_1.breadcrumbsSelector);
    var authToken = (0, react_redux_1.useSelector)(authenticity_token_1.authenticityTokenSelector);
    var siteKey = (0, react_redux_1.useSelector)(site_key_1.siteKeySelector);
    var isMobile = (0, react_redux_1.useSelector)(selectors_1.isMobileSelector);
    var content = (0, react_redux_1.useSelector)(content_1.contentSelector);
    var department = content.department;
    var constructorRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(Wrapper, { className: "resp-container content", "$mobile": isMobile },
        react_1.default.createElement(BreadcrumbsContainer_1.default, { items: breadcrumbs }),
        react_1.default.createElement(AboutCompany_1.default, null),
        react_1.default.createElement(Menu_1.default, { style: {
                display: 'block',
                flexWrap: 'nowrap',
                width: '100%'
            } }),
        department && react_1.default.createElement(ProductContainer_1.default, { innerRef: constructorRef }),
        react_1.default.createElement(Instruction_1.default, null),
        react_1.default.createElement(Reviews_1.default, null),
        department && react_1.default.createElement(PopularProducts_1.default, null),
        department && react_1.default.createElement(OtherProducts_1.default, null),
        react_1.default.createElement(WhyUs_1.default, null),
        react_1.default.createElement(Trusted_1.default, null),
        react_1.default.createElement(CTAForm_1.default, { authToken: authToken, siteKey: siteKey, isMobile: isMobile }),
        react_1.default.createElement(CustomStoreInfo_1.default, null),
        department && react_1.default.createElement(PrintInfo_1.default, null)));
};
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 50px;\n\n  div {\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n    }\n\n    ::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: #dfe0e0;\n      border-radius: 90px;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n      background: #ababab;\n      border-radius: 90px;\n    }\n\n    scrollbar-color: #dfe0e0 transparent;\n  }\n\n  ", "\n"], ["\n  margin-bottom: 50px;\n\n  div {\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n    }\n\n    ::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: #dfe0e0;\n      border-radius: 90px;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n      background: #ababab;\n      border-radius: 90px;\n    }\n\n    scrollbar-color: #dfe0e0 transparent;\n  }\n\n  ", "\n"])), function (props) { return props.$mobile && "overflow-x: hidden;"; });
exports.default = Root;
var templateObject_1;
